module.exports = __webpack_public_path__ + "static/media/unknown.b55acff0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/resources/unknown.svg
// module id = 1090
// module chunks = 0